
import Vue from 'vue';
import {urlConfig} from '@/api/urlConfig';
import numberkeyword from '@/components/numberKeyword.vue';
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import {fetch,promptMessage,baseUrl} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import step_Bg from './images/step_bg.png';
import axios from 'axios';
import NumberKeyword from "../../components/numberKeyword";
export default {
directives: {
TransferDom
},
data(){

return{
numberkeywordShow:false,
babyIconArry:[
],
deliverTypeIcon:false,
deliverHospitalIcon:false,
deliverDayIcon:false,
miscarryDateIcon:false,
diapauseIcon:false,
miscarryIcon:false,
diapauseDayIcon:false,
toastShow:false,
toastTxt:'',
step_Bg,
diapauseDayshow:false,
submitDisabled:true,
iconType:'success',
dataObj:{
diapause:'',
diapauseDay:'',
deliverHospital:'',
deliverType:'',
miscarry:'',
miscarryDate:'',
deliverDay:'',
suggestion:'',
babySituations:[
{
survivalStuation:'',
id:'',
sex:'',
score:['','',''],
weight:'',
height:'',
deathTime:'',
deathReason:'',
proDefects:'',
remark:'',
Defectshow:false,
}
],
pregCount:1,
gestationComplication:[],

},
maxDate:dateFormat(new Date(), 'YYYY-MM-DD'),
bingfazheng:[],
childbirthNum:1,
abortionIf:false,
abortionDateShow:false,
bingfazhengList:[],
heightType:function(value){
return{
valid: (value.toString()).indexOf('.') ==-1,
msg:'单位是cm，不能有小数点，请核实后填写'
}
},
weightType:function(value){
return{
valid: Number(value) <=15,
msg:'体重单位为Kg,请核实后填写'
}
},
be2333: function (value) {
return {
valid: Number(value)>=1 && Number(value)<=10,
msg: '新生儿评分又称Apgar评分法、阿氏评分，是孩子出生后立即检查他身体状况的标准评估方法。在孩子出生后，根据皮肤颜色、心搏速率、呼吸、肌张力及运动、反射五项体征进行评分。满10分者为正常新生儿，评分7分以下的新生儿考虑患有轻度窒息，评分在4分以下考虑患有重度窒息。大部分新生儿的评分多在7- 10分之间'
}
},
diapauseList: [
{key: '1', value: '是'},
{key: '2', value: '否'},
],
childbirthSexList: [
{key: '1', value: '男孩'},
{key: '2', value: '女孩'},
],
childbirthStateList: [
{key: '1', value: '活产'},
{key: '2', value: '死产'},
{key: '3', value: '死胎'},
],
childbirthDefectList:[
{key: '00', value: '无'},
{key: '01', value: '21三体综合征'},
{key: '02', value: '短肢'},
{key: '03', value: '先心病'},
{key: '04', value: '尿道下裂'},
{key: '05', value: '其它'},
{key: '06', value: '2三体'},
{key: '07', value: '16三体'},
{key: '08', value: '葡萄胎'},
{key: '09', value: '肢体畸形'},
{key: '10', value: '22三体'},
{key: '11', value: '染色体异常'},
{key: '12', value: '12三体'},
{key: '13', value: '唇腭裂'},
{key: '14', value: '脐膨出'},
{key: '15', value: '18三体'},
{key: '16', value: '脑积水'},
{key: '17', value: '癫痫'},
{key: '18', value: '听力障碍'},
{key: '19', value: '先天性结肠炎'},
{key: '20', value: '五官畸形'},
],
childbirthWayList: [
{key: '1', value: '顺产'},
{key: '2', value: '剖腹产'},
],
pregnantifList: [
{key: '2', value: '否'},
{key: '1', value: '早期流产'},
{key: '3', value: '晚期流产'},
]
}
},
components: {
Popup,numberkeyword, Toast,Icon,dateFormat ,XNumber,Cell,Checker, CheckerItem,XTextarea,PopupRadio,Datetime ,Checklist ,Group ,Radio ,XInput ,XDialog,XButton, XHeader
},
methods:{
numberkeywordcolse(){
this.numberkeywordShow = false;
if(this.scrollTop){
$('html,body').animate({scrollTop: $('body ,html').scrollTop() - 180}, 300);
this.scrollTop =false;
}


let scoreyt =0;
for(let i =0;i<this.dataObj.babySituations[this.scoreval[0]].score[this.scoreval[1]].length;i++){
if(this.dataObj.babySituations[this.scoreval[0]].score[this.scoreval[1]][i]){
scoreyt++;
}
}
if(scoreyt>0){
this.babyIconArry[this.scoreval[0]].scoreIcon = false;
}
console.log(this.babyIconArry)
},
scoreChoose(e,index,i){
console.log(e.clientY,window.innerHeight/2);
this.numberkeywordShow = true;
this.scoreval = [index,i];
this.scoreLS = '';
if(e.clientY > window.innerHeight/2){
$('html,body').animate({scrollTop: $('body ,html').scrollTop() + 180}, 300);
this.scrollTop =true;
}else{
this.scrollTop =false;
}


},
numberkeywordClick(val){
this.scoreLS += val;
if(this.scoreLS>=1 && this.scoreLS<=10){
this.$nextTick(function(){
this.dataObj.babySituations[this.scoreval[0]].score[this.scoreval[1]] = this.scoreLS;
})

}else{
this.$vux.toast.show({
type:'text',
text: '评分不能超过10分！'
})
this.scoreLS = this.scoreLS.substring(0,this.scoreLS.length-1);
this.dataObj.babySituations[this.scoreval[0]].score[this.scoreval[1]] = this.scoreLS;
}
this.$forceUpdate();
},
numberkeyworddel(){

this.scoreLS = this.scoreLS.substring(0,this.scoreLS.length-1);
this.dataObj.babySituations[this.scoreval[0]].score[this.scoreval[1]] = this.scoreLS;
this.$forceUpdate();
},
iconMethod(value,name,boole,index){

if(boole){
if(value){
this.babyIconArry[index][name + 'Icon'] = false;
}else{
this.babyIconArry[index][name + 'Icon'] = true;
}

}else {
if(value){
this[name + 'Icon'] = false;
}else{
this[name + 'Icon'] = true;
}

}

},
IconClick(text){
this.toastShow = true;
this.toastTxt = text;
},
colse(){
WeixinJSBridge.call('closeWindow');
},
scorePrompt(obj,value){
promptMessage('提示',obj(value).msg)
},
diapauseChoose(){
if(this.dataObj.diapause == 1){ //停育
this.diapauseDayshow = true;
this.diapauseIcon = false;
this.iconMethod(this.dataObj.diapauseDay,'diapauseDay');
}else if(this.dataObj.diapause == 2){ // 未停育
this.diapauseIcon = false;
this.diapauseDayshow = false;
this.dataObj.diapauseDay = '';
this.childbirthNumChoose();
}else{
this.diapauseIcon = true;
}
},//是否停育
childbirthDefectChoose(obj,index){

if(index != undefined){
if(obj.survivalStuation){
this.babyIconArry[index]['survivalStuationIcon'] = false;
}else {
this.babyIconArry[index]['survivalStuationIcon'] = true;
}
}
if(obj.survivalStuation != 1){  //死产
this.$set(obj,'Defectshow',true);
}else {
this.$set(obj,'Defectshow',false);
}

}, //出生缺陷
pregnantifchange(){
console.log(this.dataObj.miscarry,5)
if(this.dataObj.miscarry == 1 || this.dataObj.miscarry == 3){ //流产
this.iconMethod(this.dataObj.miscarryDate,'miscarryDate')
this.abortionDateShow = true;
this.miscarryIcon = false;
this.abortionIf = false;
}else if(this.dataObj.miscarry == 2){  //怀孕
this.miscarryIcon = false;
this.abortionDateShow = false;
this.childbirthNumChoose();
this.abortionIf = true;
if(this.dataObj.babySituations.length == 0){
this.childbirthNumChoose();
}
if(this.dataObj.babySituations.length ==1 && this.babyIconArry == 0){
this.babyIconArry.push({
survivalStuationIcon:true,
idIcon:true,
sexIcon:true,
scoreIcon:true,
weightIcon:true,
heightIcon:true,
deathTimeIcon:true,
deathReasonIcon:true,
proDefectsIcon:true,
remarkIcon:true,
DefectshowIcon:true,
});
}
}else{
this.miscarryIcon = true;
}
},//是否流产
iconYanzheng(){
for(let i in this.dataObj){
if(i != 'babySituations'){
if(this.dataObj[i]){
this[i + 'Icon'] = false;
}else {
this[i + 'Icon'] = true;
}
}
}

},
childbirthNumChoose(){
if(this.childbirthNum != ''){
if(this.childbirthNum > this.dataObj.babySituations.length){
for(let i = 0; i < this.childbirthNum - this.dataObj.babySituations.length;i++){
this.dataObj.babySituations.push({
survivalStuation:'',
id:'',
sex:'',
score:['','',''],
weight:'',
height:'',
deathTime:'',
deathReason:'',
proDefects:'',
remark:'',
Defectshow:false,
});
this.babyIconArry.push({
survivalStuationIcon:true,
idIcon:true,
sexIcon:true,
scoreIcon:true,
weightIcon:true,
heightIcon:true,
deathTimeIcon:true,
deathReasonIcon:true,
proDefectsIcon:true,
remarkIcon:true,
DefectshowIcon:true,
});



}
}else if(this.childbirthNum < this.dataObj.babySituations.length){
let i =  this.dataObj.babySituations.length - this.childbirthNum;
this.dataObj.babySituations.splice(this.dataObj.babySituations.length-i,i);
this.dataObj.babyIconArry.splice(this.dataObj.babyIconArry.length-i,i);
}
}
},
submitMethod(data){
console.log('提交',data)
this.submitDisabled = true;
if(this.dataObj.miscarry == 1 || this.dataObj.miscarry == 3){ //流产
data.babySituations = [];
}else{

}
if(this.dataObj.gestationComplication){
data.gestationComplication = JSON.stringify(this.dataObj.gestationComplication);
}
this.$store.commit('updateLoadingStatus',{isLoading:true})
fetch('post',urlConfig.OneInvestigationSave,data).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示','提交'+response.resultMsg,this.alertHide());
}).catch(error => {
this.submitDisabled = false;
})
},
alertHide(){
return function(){
window.location.reload();
}
},
checkerClick(item){
this.$nextTick(function(){

if(this.bingfazheng.indexOf(item) == -1){  //如果是取消
for(let j= 0;j<this.dataObj.gestationComplication.length;j++){
if(item == this.dataObj.gestationComplication[j].compliCode){
this.dataObj.gestationComplication.splice(j,1);
}
}
}else{  //如果是新增
for(let j= 0;j<this.bingfazhengList.length;j++){
if(item == this.bingfazhengList[j].key){
this.dataObj.gestationComplication.push({compliCode:this.bingfazhengList[j].key,compliName:this.bingfazhengList[j].value,compliDate:''})
}
}
}
})



},
getData(){
let url = '';

if(this.ivfCmrId && this.rsaCmrId){
url = urlConfig.OneInvestigationGet+'?ivfCmrId='+this.ivfCmrId + '&rsaCmrId='+this.rsaCmrId;
}else {

if(this.ivfCmrId){
url = urlConfig.OneInvestigationGet+'?ivfCmrId='+this.ivfCmrId;
};
if(this.rsaCmrId){
url = urlConfig.OneInvestigationGet+'?rsaCmrId='+this.rsaCmrId;
};
}

fetch('get',url).then(response => {

if(response.data !=''){ //修改
if(response.gestationComplication){
this.dataObj.gestationComplication = JSON.parse(response.gestationComplication);
for(let i =0;i<this.dataObj.gestationComplication.length;i++){
this.bingfazheng.push(this.dataObj.gestationComplication[i].compliCode);
}
}
this.dataObj.id =response.id;
this.dataObj.miscarry =response.miscarry.toString();
this.dataObj.suggestion = response.suggestion;

if(response.babySituations.length !=0){ //存活情况
this.abortionIf = true;
this.dataObj.pregCount = response.pregCount;
this.dataObj.diapause = response.diapause.toString();
this.dataObj.diapauseDay = response.diapauseDay;
this.diapauseChoose();
this.dataObj.deliverDay = response.deliverDay;
this.dataObj.deliverHospital = response.deliverHospital;
this.dataObj.babySituations = response.babySituations;
this.dataObj.deliverType = response.deliverType.toString();
this.childbirthNum = response.babySituations.length;
for(let i =0;i<this.dataObj.babySituations.length;i++){
this.childbirthDefectChoose(this.dataObj.babySituations[i]);
this.dataObj.babySituations[i].survivalStuation = this.dataObj.babySituations[i].survivalStuation.toString();
this.dataObj.babySituations[i].sex = this.dataObj.babySituations[i].sex.toString();
this.dataObj.babySituations[i].score = this.dataObj.babySituations[i].score.split(',');
this.babyIconArry.push({});
for(let j in this.dataObj.babySituations[i]){
if(this.dataObj.babySituations[i][j]){
this.babyIconArry[i][j+'Icon'] = false;
}else{
this.babyIconArry[i][j+'Icon'] = true;
}

}

}
console.log(this.babyIconArry,56)
}else{ //流产
this.dataObj.miscarryDate =response.miscarryDate;
}
if(response.followStatus == 1){ //已审核，不能修改
this.submitDisabled = true;
}else {
this.submitDisabled = false;
}
}else {  //新增
this.submitDisabled = false;
this.babyIconArry = [
{
survivalStuationIcon:true,
idIcon:true,
sexIcon:true,
scoreIcon:true,
weightIcon:true,
heightIcon:true,
deathTimeIcon:true,
deathReasonIcon:true,
proDefectsIcon:true,
remarkIcon:true,
DefectshowIcon:true,
}
]
}

this.iconYanzheng(); 
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

});
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
axios.get(baseUrl + urlConfig.getIVF+'/217').then(response => {
let responseData = response.data.data;
this.bingfazhengList = [];
for(let i = 0;i<responseData.length;i++){
this.bingfazhengList.push({key:responseData[i].sZdDm,value:responseData[i].sZdCmc});
}

}).catch(error => {

})

},
submit(){
console.log(this.babyIconArry,7)
if(this.dataObj.miscarry == 1 || this.dataObj.miscarry == 3 ){ //流产

if(this.dataObj.miscarryDate != ''){  //提交

let copyObject = {};
for(let i in this.dataObj){
copyObject[i] = this.dataObj[i];
}
copyObject['ivfCmrId'] = this.ivfCmrId;
copyObject['rsaCmrId'] = this.rsaCmrId;
this.submitMethod(copyObject);
}else {
promptMessage('提示','请选择流产时间');
}
}else {   //选择未流产
console.log(this.dataObj,4444)

let copyObject = {};
let copyBool = [];
this.dataObj.miscarryDate = '';

if(this.dataObj.deliverDay !='' && this.dataObj.deliverType !='' &&  this.childbirthNum !='' && this.dataObj.deliverHospital !='' && this.dataObj.pregCount !='' && this.dataObj.diapause !='' ){
copyObject = JSON.parse(JSON.stringify(this.dataObj));
for(let j = 0;j<copyObject.babySituations.length;j++){
if(this.dataObj.babySituations[j].Defectshow){ //未存活
let bbh = 0;
for(let z in copyObject.babySituations[j]){
if(copyObject.babySituations[j][z] != ''){
if(z !='remark' && z !='Defectshow' && z !='id'){
bbh++;
}

}
}
if(Object.keys(copyObject.babySituations[j]).length-bbh ==3 && this.weightType(copyObject.babySituations[j].weight).valid && this.heightType(copyObject.babySituations[j].height).valid){
copyBool[j] = true;
}else {
copyBool[j] = false;
}
}else {
let bbh = 0;
for(let z in copyObject.babySituations[j]){
console.log(copyObject.babySituations[j][z] != '',copyObject.babySituations[j][z],z)
if(copyObject.babySituations[j][z] != ''){

if(z !='remark' && z !='deathTime' && z !='deathReason' && z !='Defectshow' && z !='id'){
bbh++;
}
}
}
console.log(bbh,copyObject.babySituations)
console.log(Object.keys(copyObject.babySituations[j]).length-bbh == 5,this.be2333(copyObject.babySituations[j].score).valid,55,copyObject.babySituations[j].score)
if(Object.keys(copyObject.babySituations[j]).length-bbh == 5 && this.weightType(copyObject.babySituations[j].weight).valid && this.heightType(copyObject.babySituations[j].height).valid){
copyBool[j] = true;
}else {
copyBool[j] = false;
}

}
}
let mmn = 0
for(let i =0;i<copyBool.length;i++){
if(copyBool[i]){
mmn++
}
}
console.log(copyBool,5,mmn,this.childbirthNum)
if(mmn == this.childbirthNum){
copyObject['ivfCmrId'] = this.ivfCmrId;
copyObject['rsaCmrId'] = this.rsaCmrId;
for(let j = 0;j<copyObject.babySituations.length;j++){
delete copyObject.babySituations[j].Defectshow;
copyObject.babySituations[j].score = copyObject.babySituations[j].score.toString();
}
console.log(copyObject,45)
if(!this.diapauseDayshow){ //未停育，不需要填写停育日期
if(this.dataObj.pregCount != this.childbirthNum){
promptMessage('提示','生产胎数与怀孕胎数不一致，请查看是否有停育情况未填写');
}else {
this.submitMethod(copyObject);
}

}else {  //停育，需要填写停育日期
if(this.dataObj.diapauseDay == ''){
promptMessage('提示','停育日期未填写！');
}else {
if(this.dataObj.pregCount == this.childbirthNum){
promptMessage('提示','生产胎数与怀孕胎数相等，但有停育状况，请查看信息是否填写有误');
}else if(this.dataObj.pregCount < this.childbirthNum){
promptMessage('提示','怀孕胎数信息有误，请核实后重新填写');
}else {
this.submitMethod(copyObject);
}
}

}

}else{
this.iconYanzheng();
promptMessage('提示','还有选项未填写！');
}

}else{
this.iconYanzheng();
promptMessage('提示','还有选项未填写！');
}
}
}
},
mounted(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.ivfCmrId = this.$route.query.cmrsId;
this.rsaCmrId = this.$route.query.rsaCmrId;
if(this.ivfCmrId == 'undefined'){
this.ivfCmrId = '';
}
if(this.rsaCmrId == 'undefined'){
this.rsaCmrId = '';
}

getken(this.getData);
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input, .textarea').focus();
})
});
}
}



// WEBPACK FOOTER //
// ./src/project/followUpInvestigationProject/OneInvestigation.vue